import * as React from 'react';
import MainElectricBill from '../../components/bill/electric/MainElectricBill';
import { useNavigate } from 'react-router-dom';
import Storage from '../../services/Storage';

export default function ElectricBill() {
  const navigate = useNavigate();

  React.useEffect(() => {
    if (Storage.getLocalAccessToken() === null) {
      navigate('/signin', { replace: true })
    }
  }, [navigate])
  return (
    <MainElectricBill></MainElectricBill>
  );
}